export type PermissionActionDefinition = {
  name: string;
  description: string;
};

export type PermissionResourceDefinition = {
  name: string;
  code: string;
  type: 'MENU';
  description: string;
  actions: PermissionActionDefinition[];
};

const action = (
  name: string,
  description: string,
): PermissionActionDefinition => ({
  name,
  description,
});

export const PAYROLL_CENTER_PERMISSION_RESOURCES = [
  {
    name: '薪酬工作台',
    code: 'payroll-center-workbench',
    type: 'MENU',
    description: '控制薪酬工作台页面访问和待办下钻',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-todo', '打开待办'),
      action('open-drilldown', '打开下钻'),
    ],
  },
  {
    name: '我的审批',
    code: 'payroll-center-approval',
    type: 'MENU',
    description: '控制薪酬中心我的审批页面访问、审批任务查询和业务单据回跳',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-source', '回跳业务单据'),
    ],
  },
  {
    name: '薪资方案',
    code: 'payroll-center-plans',
    type: 'MENU',
    description: '控制薪资方案页面访问和方案维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-plan', '新增薪资方案'),
      action('edit-plan', '编辑薪资方案'),
      action('copy-plan', '复制薪资方案'),
      action('enable-plan', '启用薪资方案'),
      action('disable-plan', '停用薪资方案'),
      action('delete-plan', '删除薪资方案'),
      action('export-plans', '导出薪资方案'),
    ],
  },
  {
    name: '薪资项目',
    code: 'payroll-center-items',
    type: 'MENU',
    description: '控制薪资项目页面访问、薪资项目维护和公式预览',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-item', '新增薪资项目'),
      action('edit-item', '编辑薪资项目'),
      action('copy-item', '复制薪资项目'),
      action('preview-formula', '预览公式'),
      action('enable-item', '启用薪资项目'),
      action('disable-item', '停用薪资项目'),
      action('delete-item', '删除薪资项目'),
      action('export-items', '导出薪资项目'),
    ],
  },
  {
    name: '薪资增减项',
    code: 'payroll-center-inputs',
    type: 'MENU',
    description: '控制薪资增减项页面访问、维护和导入',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-input', '新增薪资增减项'),
      action('edit-input', '编辑薪资增减项'),
      action('copy-input', '复制薪资增减项'),
      action('delete-input', '删除薪资增减项'),
      action('import-inputs', '导入薪资增减项'),
      action('download-template', '下载模板'),
      action('export-inputs', '导出薪资增减项'),
    ],
  },
  {
    name: '数据导入记录',
    code: 'payroll-center-source-batches',
    type: 'MENU',
    description: '控制薪酬数据导入记录页面访问和记录清理',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-batch', '新增导入记录'),
      action('import-batch', '导入数据'),
      action('delete-source-batch', '删除导入记录'),
      action('export-batches', '导出导入记录'),
    ],
  },
  {
    name: '个税测算',
    code: 'payroll-center-tax-simulation',
    type: 'MENU',
    description: '控制个税测算页面访问和测算导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('run-simulation', '执行测算'),
      action('import-tax-data', '导入税务数据'),
      action('export-simulation', '导出测算'),
    ],
  },
  {
    name: '薪酬成本分摊',
    code: 'payroll-center-cost-allocation',
    type: 'MENU',
    description: '控制薪酬成本分摊页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('generate-allocation', '生成分摊'),
      action('export-allocation', '导出分摊'),
    ],
  },
  {
    name: '员工薪资档案',
    code: 'payroll-center-profiles',
    type: 'MENU',
    description: '控制员工薪资档案页面访问和档案维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-profile', '新增档案'),
      action('edit-profile', '编辑档案'),
      action('copy-profile', '复制档案'),
      action('enable-profile', '启用档案'),
      action('disable-profile', '停用档案'),
      action('delete-profile', '删除档案'),
      action('export-profiles', '导出档案'),
    ],
  },
  {
    name: '月度扣缴',
    code: 'payroll-center-deductions',
    type: 'MENU',
    description: '控制月度扣缴查询和扣款维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-deduction', '新增扣减'),
      action('edit-deduction', '编辑扣减'),
      action('copy-deduction', '复制扣减'),
      action('delete-deduction', '删除扣减'),
      action('download-template', '下载模板'),
      action('import-deductions', '导入扣减'),
      action('export-deductions', '导出扣减'),
    ],
  },
  {
    name: '调薪管理',
    code: 'payroll-center-adjustments',
    type: 'MENU',
    description: '控制调薪页面访问和调薪流程',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-adjustment', '新增调薪'),
      action('edit-adjustment', '编辑调薪'),
      action('approve-adjustment', '审批调薪'),
      action('cancel-adjustment', '取消调薪'),
      action('delete-adjustment', '删除调薪'),
      action('export-adjustments', '导出调薪'),
    ],
  },
  {
    name: '调薪分析',
    code: 'payroll-center-adjustment-analysis',
    type: 'MENU',
    description: '控制调薪分析页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('export-analysis', '导出分析'),
    ],
  },
  {
    name: '工资核算',
    code: 'payroll-center-runs',
    type: 'MENU',
    description: '控制工资核算页面访问和批次核算流程',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-run', '新建核算'),
      action('edit-run', '编辑核算'),
      action('calculate-run', '计算核算'),
      action('submit-run-confirmation', '提交核算确认'),
      action('approve-run', '确认核算'),
      action('archive-run', '归档核算'),
      action('reopen-run', '重开核算'),
      action('pay-run', '发放核算'),
      action('delete-run', '删除核算'),
      action('confirm-finance-delivery', '确认财务交付'),
      action('publish-payslips', '发布工资单'),
      action('apply-manual-adjustment', '应用手工调整'),
      action('confirm-zero-deductions', '确认无扣缴'),
      action('ignore-precheck-issue', '忽略预检问题'),
      action('explain-abnormality', '确认工资波动异常'),
      action('export-runs', '导出核算'),
    ],
  },
  {
    name: '工资条管理',
    code: 'payroll-center-slips',
    type: 'MENU',
    description: '控制工资条管理页面访问和工资单处理',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-slip', '查看工资单'),
      action('confirm-slip', '确认工资单'),
      action('confirm-abnormality', '确认异常'),
      action('withdraw-slip', '撤回工资单'),
      action('delete-slip', '删除工资单'),
      action('export-slips', '导出工资单'),
    ],
  },
  {
    name: '我的工资条',
    code: 'payroll-center-my-slips',
    type: 'MENU',
    description: '控制我的工资条页面访问和确认',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-slip', '查看工资单'),
      action('confirm-slip', '确认工资单'),
      action('export-slips', '导出工资单'),
    ],
  },
  {
    name: '团队薪酬汇总',
    code: 'payroll-center-team-summary',
    type: 'MENU',
    description: '控制团队薪酬汇总页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('export-summary', '导出汇总'),
    ],
  },
  {
    name: '薪酬操作审计',
    code: 'payroll-center-audits',
    type: 'MENU',
    description: '控制薪酬操作审计页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-detail', '查看详情'),
      action('export-audits', '导出审计'),
    ],
  },
  {
    name: '审批流程设置',
    code: 'payroll-center-workflow-settings',
    type: 'MENU',
    description: '控制薪酬审批流程设置页面访问和流程启停保存',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('configure-workflow', '设置审批流程'),
      action('save-workflow-settings', '保存审批流程设置'),
    ],
  },
] as const satisfies readonly PermissionResourceDefinition[];

export const PAYROLL_PERMISSION_RESOURCE_CODES = {
  workbench: 'payroll-center-workbench',
  approval: 'payroll-center-approval',
  plans: 'payroll-center-plans',
  items: 'payroll-center-items',
  inputs: 'payroll-center-inputs',
  sourceBatches: 'payroll-center-source-batches',
  taxSimulation: 'payroll-center-tax-simulation',
  costAllocation: 'payroll-center-cost-allocation',
  profiles: 'payroll-center-profiles',
  deductions: 'payroll-center-deductions',
  adjustments: 'payroll-center-adjustments',
  adjustmentAnalysis: 'payroll-center-adjustment-analysis',
  runs: 'payroll-center-runs',
  slips: 'payroll-center-slips',
  mySlips: 'payroll-center-my-slips',
  teamSummary: 'payroll-center-team-summary',
  audits: 'payroll-center-audits',
  workflowSettings: 'payroll-center-workflow-settings',
} as const;
